import { createSelector } from 'reselect';

const getHasLoaded = createSelector(
  (state) => state.readTogetherCollections.hasLoaded,
  (hasLoaded) => hasLoaded
);
const getCurrencyData = createSelector(
  (state) => state.readTogetherCollections.data.currency,
  (currency = {}) => currency
);
const getCollectionsData = createSelector(
  (state) => state.readTogetherCollections.data.readTogetherCollections,
  (collections = []) => collections
);
const getPageCount = createSelector(
  (state) => state.readTogetherCollections.data.pageCount,
  (pageCount) => pageCount || 0
);

export default {
  getCollectionsData,
  getCurrencyData,
  getHasLoaded,
  getPageCount,
};
